import { Box, Button, Popover, TextField } from '@mui/material';
import { FC } from 'react';
import { PlanningsDriverEntity } from 'src/entities/PlanningsDriver.entity';
import { PlanningsTruckEntity } from 'src/entities/PlanningsTruck.entity';
import DriverSelectMenu from 'src/pages/ConvenienceDispatches/DriverSelectMenu';
import TruckSelectMenu from 'src/pages/ConvenienceDispatches/TruckSelectMenu';

export type VehicleAssignmentMenusProps = {
  trucks: PlanningsTruckEntity[];
  drivers: PlanningsDriverEntity[];

  truckAnchorEl: HTMLElement | null;
  currentTruckId: number | null;
  excludeTruckIds: ReadonlySet<number>;
  onTruckClose: () => void;
  onTruckSelect: (truckId: number) => void;

  driverAnchorEl: HTMLElement | null;
  currentDriverId: number | null;
  excludeDriverIds: ReadonlySet<number>;
  onDriverClose: () => void;
  onDriverSelect: (driverId: number) => void;
  /** 打ち込んだ名前で割り当てる。未指定ならメニューに手入力の導線を出さない */
  onDriverCreate?: (name: string) => void;

  plateAnchorEl: HTMLElement | null;
  plateValue: string;
  onPlateChange: (value: string) => void;
  onPlateClose: () => void;
  onPlateSubmit: () => void;
};

/**
 * 車両 / ドライバー / 車番の変更 UI。カード配車と /map で共有する。
 *
 * 3 つとも常時マウントし、anchor の有無だけで開閉する（カード配車の元の描き方のまま）。
 */
export const VehicleAssignmentMenus: FC<VehicleAssignmentMenusProps> = ({
  trucks, drivers,
  truckAnchorEl, currentTruckId, excludeTruckIds, onTruckClose, onTruckSelect,
  driverAnchorEl, currentDriverId, excludeDriverIds, onDriverClose, onDriverSelect, onDriverCreate,
  plateAnchorEl, plateValue, onPlateChange, onPlateClose, onPlateSubmit,
}) => (
  <>
    <TruckSelectMenu
      anchorEl={truckAnchorEl}
      onClose={onTruckClose}
      onSelect={(t) => onTruckSelect(t.id)}
      trucks={trucks}
      excludeTruckIds={excludeTruckIds}
      currentTruckId={currentTruckId}
    />
    <DriverSelectMenu
      anchorEl={driverAnchorEl}
      onClose={onDriverClose}
      onSelect={(d) => onDriverSelect(d.id)}
      onCreate={onDriverCreate}
      drivers={drivers}
      excludeDriverIds={excludeDriverIds}
      currentDriverId={currentDriverId}
    />
    <Popover
      open={Boolean(plateAnchorEl)}
      anchorEl={plateAnchorEl}
      onClose={onPlateClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1 }}>
        <TextField
          size="small"
          value={plateValue}
          onChange={(e) => onPlateChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); onPlateSubmit(); }
            if (e.key === 'Escape') { onPlateClose(); }
          }}
          inputRef={(el: HTMLInputElement | null) => { el?.focus(); }}
          placeholder="車番"
          inputProps={{ 'aria-label': '車番' }}
          sx={{ width: 180 }}
        />
        <Button size="small" variant="contained" onClick={onPlateSubmit}>
          保存
        </Button>
      </Box>
    </Popover>
  </>
);

export default VehicleAssignmentMenus;
